export const OPTION_KEY_ALL_COMPANIES = -1;
export const OPTION_ALL_COMPANIES = {
  key: OPTION_KEY_ALL_COMPANIES,
  text: 'All',
};

export const OPTION_KEY_GLOBALE_PROJECT_USERS = 0;
export const OPTION_GLOBALE_PROJECT_USERS = { key: OPTION_KEY_GLOBALE_PROJECT_USERS, text: 'Global Project Users' };

export type TTeamDisplayMode = 'allUsers' | 'company' | 'projectRequect' | 'companyGlobal';
